import _slicedToArray from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectSpread from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.filter.js";
// Copyright 2017-2022 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { map, of, switchMap } from 'rxjs';
import { BN_ZERO, bnToBn } from '@polkadot/util';
import { memo } from "../util/index.js";

function orderBags(ids, bags) {
  var sorted = ids.map(function (id, index) {
    return {
      bag: bags[index].unwrapOr(null),
      id: id,
      key: id.toString()
    };
  }).sort(function (a, b) {
    return b.id.cmp(a.id);
  }).map(function (base, index) {
    return _objectSpread(_objectSpread({}, base), {}, {
      bagLower: BN_ZERO,
      bagUpper: base.id,
      index: index
    });
  });
  var max = sorted.length - 1;
  return sorted.map(function (entry, index) {
    return index === max ? entry // We could probably use a .add(BN_ONE) here
    : _objectSpread(_objectSpread({}, entry), {}, {
      bagLower: sorted[index + 1].bagUpper
    });
  });
}

export function _getIds(instanceId, api) {
  return memo(instanceId, function (_ids) {
    var ids = _ids.map(function (id) {
      return bnToBn(id);
    });

    return ids.length ? (api.query.voterList || api.query.bagsList).listBags.multi(ids).pipe(map(function (bags) {
      return orderBags(ids, bags);
    })) : of([]);
  });
}
export function all(instanceId, api) {
  return memo(instanceId, function () {
    return (api.query.voterList || api.query.bagsList).listBags.keys().pipe(switchMap(function (keys) {
      return api.derive.bagsList._getIds(keys.map(function (_ref) {
        var _ref$args = _slicedToArray(_ref.args, 1),
            id = _ref$args[0];

        return id;
      }));
    }), map(function (list) {
      return list.filter(function (_ref2) {
        var bag = _ref2.bag;
        return bag;
      });
    }));
  });
}
export function get(instanceId, api) {
  return memo(instanceId, function (id) {
    return api.derive.bagsList._getIds([bnToBn(id)]).pipe(map(function (bags) {
      return bags[0];
    }));
  });
}